if (!customElements.get('dsgn-project-modal')) {
  customElements.define(
    'dsgn-project-modal',
    class DSGNProjectModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('[role="dialog"]');
        this.closeBtn = this.querySelector('.dsgn-project-modal__close');

        this.closeBtn.addEventListener('click', this.hide.bind(this));

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        // Click on the backdrop (the custom element itself) closes the modal
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }

      connectedCallback() {
        // Move to body so the modal sits above all page content
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
      }

      show(opener) {
        this.openedBy = opener;
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        trapFocus(this, this.dialog);
      }

      hide() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.openedBy);
      }
    }
  );
}

// Delegate tile clicks to the correct modal
document.addEventListener('click', (event) => {
  const tile = event.target.closest('[data-modal-id]');
  if (!tile) return;
  const modal = document.getElementById(tile.dataset.modalId);
  if (modal) modal.show(tile);
});
